import React from "react";
import empresasInicio from "../../../assets/EmpresasInicio2.jpg";
import { useEmpresasLanguage } from "../../../context/EmpresasLanguageContext";

const HeroSection = () => {
  const { t } = useEmpresasLanguage();
  const e = t.empresas;

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[550px] lg:min-h-[750px] flex items-end py-12 overflow-hidden">
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: `url(${empresasInicio})`,
          backgroundPosition: "50% 20%",
        }}
      />
      <div className="absolute inset-0 bg-black/40 lg:bg-black/25" />

      <div className="relative z-10 w-full flex justify-center lg:justify-start px-6 sm:px-10 lg:px-16">
        <div className="max-w-3xl flex flex-col gap-6 text-center lg:text-left">
          <h1
            className="text-white text-3xl sm:text-5xl lg:text-7xl font-extrabold leading-tight tracking-wide"
            style={{ textShadow: "1px 1px 40px rgba(0,0,0,1)" }}
          >
            {e.heroTitle}
            <br className="hidden sm:block" />
            {e.heroTitleBreak}
          </h1>
          <p
            className="text-white/90 text-lg sm:text-xl lg:text-2xl font-semibold max-w-2xl"
            style={{ textShadow: "1px 1px 20px rgba(0,0,0,0.8)" }}
          >
            {e.heroSubtitle}
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
